
<div>
  <img src="assets/images/maintenance.png"/>

  <!-- <section *ngIf="!languageReactive">
    <h1>{{"maintenance.title" | translate}}</h1>
    <h4>{{"maintenance.message" | translate}}</h4>
  </section>

  <section *ngIf="languageReactive">
    <h1>{{languageReactive.title}}</h1>
    <h4>{{languageReactive.text}}</h4>
  </section> -->

  <markdown [data]="markdownContent"></markdown>

</div>

